import { Modal, AsyncSelect } from "components";
import { Button } from "expano-components";
import getStandardProducts from "utils/select_options/getStandardProducts";
import useCreate from "hooks/useCreate";
import { useState } from "react";

const AddVirtual = ({ virtual_id, refetch, handleClose }) => {
  const [alternative_id, setAlternativeId] = useState(null);
  const { is_creating, create } = useCreate({
    path: "/product_substitutes",
    onSuccess: () => [refetch(), handleClose()],
  });

  const handleCreate = () => create({ alternative_id, virtual_id });

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Dodaj produkt",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={!alternative_id || is_creating}
            onClick={handleCreate}
          />
        </>
      }
    >
      <AsyncSelect
        label="Wybierz produkt, który będzie częścią substytutu:"
        getData={(q) => getStandardProducts(q)}
        onChange={({ value }) => setAlternativeId(value)}
      />
    </Modal>
  );
};

export default AddVirtual;
